var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClever(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Clever logo icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8207 5.51037C25.3127 1.14796 16.7324 -0.369153 10.7688 2.38166C4.29907 5.36588 1.25686 11.1343 2.154 18.6809C2.8096 24.2326 7.80709 29.4897 13.5004 30.6011C20.1427 31.9071 25.2725 29.9287 29.0968 25.7997C27.9869 24.7661 26.6297 23.449 25.5082 22.3987C20.4705 26.9112 14.202 26.361 10.7285 22.432C7.58281 18.8754 7.43904 13.1682 10.7285 9.65048C12.025 8.31619 13.6701 7.34472 15.4902 6.83854C19.0615 5.89381 22.2072 7.39426 25.0712 9.51711L28.8207 5.51037Z",
    fill: "#4670FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClever);
export default __webpack_public_path__ + "static/media/Clever.e29fd49d9eb2b45cdc153a302ea22abf.svg";
export { ForwardRef as ReactComponent };